import { render, staticRenderFns } from "./project-plan.vue?vue&type=template&id=9f8834a6&scoped=true"
import script from "./project-plan.vue?vue&type=script&lang=js"
export * from "./project-plan.vue?vue&type=script&lang=js"
import style0 from "./project-plan.vue?vue&type=style&index=0&id=9f8834a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8834a6",
  null
  
)

export default component.exports